import { ContentDataFragment, isContentItem, isContentListItemFragment } from './ContentDataFragment'

export const getContentDefaultImageUrl = (content: ContentDataFragment): string | null => {
  if (isContentListItemFragment(content)) {
    return content?.defaultImage && content?.defaultImage?.length > 0 ? content?.defaultImage?.[0]?.url || null : null
  }
  if (isContentItem(content)) {
    const raw = content.defaultImage as unknown
    return Array.isArray(raw) ? raw[0]?.url || null : (raw as string | null) || null
  }
  return null
}
